module.exports = __webpack_public_path__ + "img/ltkfamily-4x.1d7958b.jpg";